export const actionTypes = {
  SHOW_LOGIN: "SHOW_LOGIN",
  HIDE_LOGIN: "HIDE_LOGIN",
  INIT_LOGIN: "INIT_LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGOUT_INIT: "LOGOUT_INIT",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
};

export const config = {
  SECRET: "DUEOSMXdnx209262sfhfasf37294zmowhlsenxlz",
};
